let debounce = function (callback, delay) {
    let timer = null
    return function () {
        let context = this
        let args = arguments
        clearTimeout(timer)
        timer = setTimeout(function () {
            callback.apply(context, args)
        }, delay)
    }
}

let ajax = function (url) {
    return new Promise(function (resolve, reject) {
        const xmlReq = new XMLHttpRequest()
        xmlReq.open('GET', url, true)
        xmlReq.onreadystatechange = function () {
            if (xmlReq.readyState == 4) {
                if (xmlReq.status == 200) {
                    resolve(xmlReq.responseText)
                } else {
                    reject(xmlReq)
                }
            }
        }
        xmlReq.send()
    })
}

let ajax_post = function (url, params) {
    return new Promise(function (resolve, reject) {
        const xmlReq = new XMLHttpRequest()
        xmlReq.open('POST', url, true)
        xmlReq.setRequestHeader("Content-type", "application/x-www-form-urlencoded")
        xmlReq.onreadystatechange = function () {
            if (xmlReq.readyState == 4) {
                if (xmlReq.status == 200) {
                    resolve(xmlReq.responseText)
                } else {
                    reject(xmlReq)
                }
            }
        }
        xmlReq.send(params)
    })
}

let ajax_img = function (url, params) {
    return new Promise(function (resolve, reject) {
        const xmlReq = new XMLHttpRequest()
        xmlReq.open('POST', url, true)
        // xmlReq.setRequestHeader("Content-type", "multipart/form-data")
        xmlReq.onreadystatechange = function () {
            if (xmlReq.readyState == 4) {
                if (xmlReq.status == 200) {
                    resolve(xmlReq.responseText)
                } else {
                    reject(xmlReq)
                }
            }
        }
        xmlReq.send(params)
    })
}

let containsObject = function (obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        if (list[i].text == obj) {
            return true;
        }
    }

    return false;
}

export {debounce, ajax, ajax_post, ajax_img, containsObject}